/**
 * dutiesFormat: turn the stored Duties & Responsibilities text into display blocks.
 * Presentation only. Every non-blank source line is returned once, in order, with its text
 * unchanged, so what the person reads and signs is exactly the stored duties version.
 *
 * Block kinds:
 *   title    first non-blank line (the position title)
 *   meta     "Reports to ..." lines
 *   note     "Note: ..." lines
 *   heading  section headings (Duties and Responsibilities, Authorities, Qualifications ..., Responsibilities, ...)
 *   item     everything else
 */
const HEADING = new RegExp(
  "^(" + [
    "duties\\s*(and|&)\\s*responsibilities",
    "responsibilities",
    "authorit(y|ies)",
    "qualifications(\\s*\\(.*\\))?",
    "education",
    "training",
    "experience",
    "requirements",
    "minimum job requirements",
    "conditions of employment",
    "essential functions",
    "physical requirements",
    "working conditions",
    "skills",
  ].join("|") + ")\\s*:?$",
  "i",
);

export function formatDuties(text) {
  const lines = String(text || "").split(/\r?\n/);
  const out = [];
  let sawTitle = false;
  for (const raw of lines) {
    const line = raw.trim();
    if (!line) continue;
    let kind = "item";
    const beforeSections = !out.some((b) => b.kind === "heading");
    if (beforeSections && /^reports\s+to\b/i.test(line)) kind = "meta";
    else if (/^note\s*:/i.test(line)) kind = "note";
    else if (HEADING.test(line)) kind = "heading";
    else if (!sawTitle && !out.some((b) => b.kind === "heading" || b.kind === "meta")) kind = "title";
    if (kind === "title" || kind === "heading" || kind === "meta") sawTitle = true;
    out.push({ kind, text: line });
  }
  return out;
}
